<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Assegna autovettura</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <b>{{vehicleToSet.plate}}</b>
            (#{{vehicleToSet.id}}) -
            {{ vehicleToSet.model.brand.name }}
            {{ vehicleToSet.model.name }}
        </div>

        <div class="my-3">
            <label for="motivazione">Scegli motivazione</label>
            <select class="form-control" id="motivazione" [(ngModel)]="selectedMotivation"
                (change)="onMotivationChange($event)">
                <option *ngFor="let motivation of travelMotivations" [ngValue]="motivation">
                    {{ motivation['name'] }}
                </option>
            </select>
        </div>


        <div *ngIf="selectedMotivation?.id === 3" class="form-group">
            <label for="motivazione">Motivazione - Altro</label>
            <textarea class="form-control height250" id="motivazione" [(ngModel)]="new_travel.motivation_other"
                maxlength="80"></textarea>
        </div>
        <div class="form-group">
            <label for="motivazione">Persone Trasportate</label>
            <textarea class="form-control height250" id="passengers" [(ngModel)]="new_travel.passengers"
                maxlength="80"></textarea>
        </div>

        <!--<div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text" >Email responsabile</span>
      </div>
      <input type="text" class="form-control"
             placeholder="Email responsabile gerarchico" [(ngModel)]="email_responsabile"
             aria-label="Email responsabile gerarchico">
    </div>-->

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Richiedi da</span>
            </div>
            <input type="text" class="form-control" style="height: auto;" #dp="bsDatepicker" bsDatepicker
                [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                [(bsValue)]="new_travel.required_from" [disabled]="new_travel.travelStarted()">
            <timepicker [(ngModel)]="new_travel.required_from" [showMeridian]="false"
                [disabled]="new_travel.travelStarted()"></timepicker>
        </div>

        <div class="input-group my-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Richiedi a</span>
            </div>
            <input type="text" class="form-control" #dp="bsDatepicker" style="height: auto;" bsDatepicker
                [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}" [(bsValue)]="new_travel.required_to"
                [disabled]="new_travel.travelStarted()">
            <timepicker [(ngModel)]="new_travel.required_to" [showMeridian]="false"
                [disabled]="new_travel.travelStarted()"></timepicker>
        </div>


        <div class="input-group my-3">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon14">Cerca utente</span>
            </div>
            <input type="text" class="form-control" placeholder="Cerca per cognome, CF o email ..."
                (input)="onUserNameChanged(userInput.value)" #userInput aria-label="Cerca..."
                aria-describedby="basic-addon1">
        </div>

        <ul class="user-search-list list-group my-3" #listGroup [hidden]="mydataz.users.length == 0">
            <li class="list-group-item" style="  font-size: 10px; padding: 10px;" *ngFor="let user of mydataz.users"
                [class.active]="new_travel.user === user" (click)="userSelected(user)">{{user.name}} {{user.surname}}
                ({{user.email}})</li>
        </ul>

        <!--<div class="input-group mb-1">
      <input auto-complete [(ngModel)]="myData" [source]="data"
             (input)="onUserNameChanged($event)"
             [list-formatter]="myListFormatter"/>
    </div>-->

        <div class="resulted-users">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon165">Nome</span>
                </div>
                <p class="form-control">{{ new_travel.user ? new_travel.user.name || '' : '' }}</p>
            </div>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon16">Cognome</span>
                </div>
                <p class="form-control">{{ new_travel.user ? new_travel.user.surname || '' : '' }}</p>
            </div>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon18">Email</span>
                </div>
                <p class="form-control">{{ new_travel.user ? new_travel.user.email || '' : '' }}</p>
            </div>
        </div>
        <div class="my-2">
            <app-itinerario [itinerario]="itinerario" [modifications]="false"></app-itinerario>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">Annulla</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
            [disabled]="dom_elements.assign_btn.is_running" (click)="setAndApprove()">
            {{ dom_elements.assign_btn.is_running ?
            dom_elements.assign_btn.txt_run :
            dom_elements.assign_btn.txt_not_run}}
        </button>
    </div>
</ng-template>